import React from "react";
import theme from "theme";
import { Theme, Strong, Text, Box, Icon, LinkBox, Link, Section } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
import { MdPhone } from "react-icons/md";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"contacts"} />
		<Helmet>
			<title>
				FitPro Gym Franchise
			</title>
			<meta name={"description"} content={"A FITNESS REVOLUTION DESIGNED FOR THE MODERN LIFESTYLE"} />
			<meta property={"og:title"} content={"FitPro Gym Franchise"} />
			<meta property={"og:description"} content={"A FITNESS REVOLUTION DESIGNED FOR THE MODERN LIFESTYLE"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} />
			<meta name={"msapplication-TileColor"} content={"#232323"} />
		</Helmet>
		<Components.Header />
		<Section padding="0 0 0px 0" background="--color-dark" quarkly-title="Footer-13" sm-padding="50px 0 50px 0">
			<Box
				min-width="100px"
				min-height="100px"
				padding="160px 30px 80px 30px"
				background="linear-gradient(180deg,rgba(3, 7, 36, 0.85) 0%,rgba(3, 7, 36, 0.79) 99%) 0 0 no-repeat,rgba(0, 0, 0, 0) url(https://images.unsplash.com/photo-1590150392093-a552544eed09?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000) 50% 75%/auto repeat scroll padding-box"
				display="flex"
				justify-content="space-around"
				align-items="center"
				margin="0px 0px 80px 0px"
				md-flex-direction="column"
				md-align-items="stretch"
				md-margin="0px 0px 50px 0px"
				md-padding="30px 30px 30px 30px"
				sm-padding="20px 15px 20px 15px"
			>
				<Box
					min-width="100px"
					min-height="100px"
					width="60%"
					md-margin="0px 0px 30px 0px"
					md-width="100%"
					sm-margin="0px 0px 18px 0px"
				>
					<Text
						margin="0px 0px 20px 0px"
						font="normal 400 42px/1.2 --fontFamily-sansHelvetica"
						color="--light"
						md-margin="0px 0px 15px 0px"
						sm-margin="0px 0px 12px 0px"
					>
						<Strong>
							Contact Us
						</Strong>
					</Text>
					<Text
						margin="0px 0px 20px 0px"
						font="--headline4"
						color="--light"
						md-margin="0px 0px 15px 0px"
						sm-margin="0px 0px 12px 0px"
					>
						Ready to join the FitPro Gym family and make a difference in your community? Contact us today to learn more about our franchise opportunities. Together, we can inspire healthier, happier lives!
					</Text>
				</Box>
				<LinkBox
					flex-direction="row"
					padding="15px 25px 15px 25px"
					border-width="2px"
					border-style="solid"
					border-color="--color-light"
					background="rgba(247, 251, 255, 0.12)"
					sm-padding="10px 15px 10px 15px"
					href="#"
				>
					<Icon
						category="md"
						icon={MdPhone}
						size="24px"
						color="--light"
						margin="0px 8px 0px 0px"
					/>
					<Text margin="0px 0px 0px 0px" font="normal 500 20px/1.5 --fontFamily-sans" color="--light">
						+12892966051
					</Text>
				</LinkBox>
			</Box>
			<Box
				min-width="100px"
				min-height="100px"
				display="grid"
				grid-template-columns="repeat(2, 1fr)"
				grid-gap="16px 24px"
				margin="0px 0px 80px 0px"
				md-grid-template-columns="1fr"
				md-grid-gap="36px 0"
				md-margin="0px 0px 50px 0px"
			>
				<Box min-width="100px" min-height="100px">
					<Text
						margin="0px 0px 20px 0px"
						color="#d7c7c5"
						font="--headline5"
						text-align="center"
						border-color="#b8acac"
						md-margin="0px 0px 15px 0px"
					>
						7555 Montrose Rd #I7, Niagara Falls,
						<br />
						{" "}ON L2H 2E9
					</Text>
				</Box>
				<Box
					min-width="100px"
					min-height="100px"
					display="flex"
					flex-direction="column"
					align-items="center"
				>
					<Link
						href="#"
						color="#d7c7c5"
						text-decoration-line="initial"
						font="--headline5"
						display="flex"
						text-align="center"
						margin="0px 0px 15px 0px"
						hover-color="#f5eceb"
					>
						+12892966051
					</Link>
					<Link
						href="mailto:info@fitprogym.com"
						color="#d7c7c5"
						text-decoration-line="initial"
						font="--headline5"
						display="flex"
						margin="0px 0px 15px 0px"
						text-align="center"
						hover-color="#f5eceb"
					>
						info@fitprogym.com
					</Link>
				</Box>
			</Box>
		</Section>
		<Components.HowTo />
		<Components.Fi />
		<Components.Footer3>
			<Override slot="linkBox" href="/" />
		</Components.Footer3>
		<RawHtml>
			<style place={"endOfHead"} rawKey={"6166a2b829a0a1001e6ca5fb"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"}
			</style>
		</RawHtml>
	</Theme>;
});